import axios, { AxiosResponse } from "axios";
import axiosRetry from "axios-retry";
import { getResponseMessage, IBaseRequest, IBaseResponse } from "core/interfaces/data/Base";
import { IGetFirebaseTokenResponse, IRegistrazioneFirebaseUtenteRequest } from "core/interfaces/data/IFirebaseRequest";

// questo serve per fare la richiesta una seconda volta se in caso la prima non va a buon fine
axiosRetry(axios, {
	retries: 2,
});

// serve per settare i cookie in risposta
axios.defaults.withCredentials = true;

class FirebaseRepository {
	async SetFirebaseToken(props: IRegistrazioneFirebaseUtenteRequest): Promise<boolean> {
		const url = `${window.CONFIG.REACT_APP_WS_HSB}/InsertFirebaseToken`;

		try {
			const res = await axios.post<IRegistrazioneFirebaseUtenteRequest, AxiosResponse<IBaseResponse>>(url, props);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			return res.data.Result;
		} catch (err) {
			console.log(err);
			return false;
		}
	}
	async GetFirebaseToken(props: IBaseRequest): Promise<string | undefined> {
		const url = `${window.CONFIG.REACT_APP_WS_HSB}/GetFirebaseToken`;

		try {
			const res = await axios.post<IBaseRequest, AxiosResponse<IGetFirebaseTokenResponse>>(url, props);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			return res.data.TokenFCM;
		} catch (err) {
			console.log(err);
			return undefined;
		}
	}
}
var FirebaseRep=new FirebaseRepository()
export default FirebaseRep;
